import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Anchor, AnchorLink} from 'kpc';

var _$tmp0 = {
    'href': 'components-anchor-demos-basic',
    'title': '基础用法'
};
var _$tmp1 = {
    'href': 'components-anchor-demos-horizontal',
    'title': '水平排列'
};
var _$tmp2 = {
    'href': 'components-anchor-demos-container',
    'title': '自定义滚动容器',
    'disabled': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$cc(Anchor, {
            'offset': 76,
            'children': [
                _$cc(AnchorLink, _$tmp0),
                _$cc(AnchorLink, _$tmp1),
                _$cc(AnchorLink, _$tmp2)
            ],
            'ev-$model:value': function($v) {
                $this.set('activeAnchor', $v);
            },
            'value': $this.get('activeAnchor')
        })
    ), 2, 'anchor-demo');
};